import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    destroy: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.delete(`/backofficepayment/locations/${url.id}`, config),
    fetch: (config: AxiosRequestConfig) =>
        api.get(`/backofficepayment/locations`, config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/backofficepayment/locations/${url.id}`, config),
    store: (data: object, config: AxiosRequestConfig) =>
        api.post(`/backofficepayment/locations`, data, config),
    update: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.put(`/backofficepayment/locations/${url.id}`, data, config),
    patch: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.patch(`/backofficepayment/locations/${url.id}`, data, config),
};

export default requests;
